import axios from 'axios';

export function isDescriptionTooLongError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false;

  const responseData: unknown = error.response?.data;

  let issues: unknown[] = [];
  if (Array.isArray(responseData)) {
    issues = responseData;
  } else if (Array.isArray((responseData as { issues?: unknown[] })?.issues)) {
    issues = (responseData as { issues: unknown[] }).issues;
  } else {
    const msg = (responseData as { message?: string })?.message;
    if (typeof msg === 'string') {
      try {
        const parsed: unknown = JSON.parse(msg);
        if (Array.isArray(parsed)) issues = parsed;
      } catch {}
    }
  }

  return issues.some((issue) => {
    const i = issue as { code?: string; path?: unknown[] };
    return (
      i.code === 'too_big' &&
      Array.isArray(i.path) &&
      i.path.length === 1 &&
      i.path[0] === 'description'
    );
  });
}
